import React from 'react';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';

interface SuccessfulPhaseBodyProps {
	description?: string;
}

export const SuccessfulPhaseBody: React.FC<SuccessfulPhaseBodyProps> = ({
	description = 'Your identity has been verified. Next, upload your documentation to continue.',
}) => (
	<div className="min-h-[360px] flex flex-col items-center justify-center py-8">
		<div className="w-24 h-24 rounded-full bg-[#40BB711A] flex items-center justify-center mb-6 border-2 border-[#40BB7126]">
			<Icon
				src={Icons.tickCircle}
				className="!text-main-green"
				width={40}
				height={40}
			/>
		</div>
		<Typography type="semibold-24" className="text-center">
			Verification Successful
		</Typography>
		<Typography
			type="regular-16"
			className="text-center text-gray-35 mt-2 max-w-md"
		>
			{description}
		</Typography>
	</div>
);

interface SuccessfulPhaseFooterProps {
	onContinue: () => void;
	label?: string;
}

export const SuccessfulPhaseFooter: React.FC<SuccessfulPhaseFooterProps> = ({
	onContinue,
	label = 'Continue',
}) => (
	<div className="flex justify-end">
		<Button
			decoration="primary"
			icon={Icons.arrowRight}
			iconRight
			onClick={onContinue}
			size="fit"
			label={label}
		/>
	</div>
);
